<p-card>

  <p-header>
    <div>{{ title | uppercase }}</div>
    <ng-content select="[title-flag]"></ng-content>

    <div class="navigation">
      <a *ngIf="expanded === false"
         (click)="sizeChanged.emit()">
        <i class="fa fa-plus-square"></i>
      </a>
      <a *ngIf="expanded === true"
         (click)="sizeChanged.emit()">
        <i class="fa fa-minus-square"></i>
      </a>
      <a *ngIf="redirectTo"
         [routerLink]="redirectTo">
        <i class="fa fa-external-link-square"></i>
      </a>
    </div>
  </p-header>

  <div *ngIf="!loading; else spinner">
    <ng-content></ng-content>
  </div>

  <p-footer *ngIf="info">
    <a (click)="infoClicked.emit()" class="info-icon">
      <i class="fa fa-info-circle"></i>
    </a>
  </p-footer>
</p-card>

<ng-template #spinner>
  <div class="text-center vertical-margin">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</ng-template>
